import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as THREE from 'three';

export class CameraManager {
    constructor(Camera, Canvas) {
        this.Camera = Camera;
        this.Canvas = Canvas;

        this.orbit = new OrbitControls(this.Camera, this.Canvas);
        this.orbit.enabled = false;
        this.orbit.enableDamping = true;
        this.orbit.maxPolarAngle = Math.PI / 2.5;
        
        this.targetPosition = new THREE.Vector3();
        this.lookAtTarget = new THREE.Vector3();
        this.currentLookVector = new THREE.Vector3(); 
        
        this.isLerping = false;
        this.lerpSpeed = 4;

        this.stations = [];
        this.centerPos = new THREE.Vector3();
        this.stationIndex = 0;
        this.isZoomed = false;
    }

    setupLobby(center, stations) {
        this.stations = stations;
        this.centerPos.copy(center);
        this.targetPosition.copy(center);
        
        // 1. Hard Snap to center
        this.Camera.position.copy(center);

        if (this.stations.length > 0) {
            this.lookAtTarget.copy(this.stations[0].lookAt);
            this.currentLookVector.copy(this.stations[0].lookAt);
            this.Camera.lookAt(this.currentLookVector);
        }
        
        // 2. Kill the controls immediately
        this.setMode('LOBBY'); 

        this.isLerping = false; 
        this.isZoomed = false;
        this.stationIndex = 0;
    }

    changeStation(direction) {
        if (this.isZoomed || this.stations.length === 0) return;
        this.stationIndex = (this.stationIndex + direction + this.stations.length) % this.stations.length;
        this.lookAtTarget.copy(this.stations[this.stationIndex].lookAt);
        this.isLerping = true; 
    }

    zoomIn() {
        if (this.isZoomed || this.stations.length === 0) return;
        this.targetPosition.copy(this.stations[this.stationIndex].moveTo);
        this.isZoomed = true;
        this.isLerping = true;
    }

    zoomOut() {
        if (!this.isZoomed) return;
        this.targetPosition.copy(this.centerPos);
        this.isZoomed = false;
        this.isLerping = true;
    }

    setMode(mode, target = new THREE.Vector3(0, 0, 0)) {
        this.orbit.autoRotate = false;

        if (mode === 'ORBIT' || mode === 'ROTATE') {
            this.orbit.enabled = true;
            this.isLerping = false;
            this.orbit.autoRotate = (mode === 'ROTATE');
            this.orbit.target.copy(target);
            this.orbit.update(); // Sync before taking control
        } else {
            // Mode 'LOBBY'
            this.orbit.enabled = false;
            
            // CRITICAL: Sync Orbit target to where the camera is currently looking.
            // This 'releases' the camera so manual lerping can take over.
            const dir = new THREE.Vector3();
            this.Camera.getWorldDirection(dir);
            this.orbit.target.copy(this.Camera.position).add(dir);
            this.orbit.update(); 
        }
    }

    update(dt) {
        // ALWAYS check isLerping first and bypass Orbit entirely
        if (this.isLerping) {
            const safeDt = (dt !== undefined && dt < 0.1) ? dt : 0.016;
            const factor = this.lerpSpeed * safeDt;
            
            // Lerp spatial position
            this.Camera.position.lerp(this.targetPosition, factor);

            // Lerp look-at target
            this.currentLookVector.lerp(this.lookAtTarget, factor);
            
            // Force the camera to look at our moving target
            this.Camera.lookAt(this.currentLookVector);

            // Distance Check
            const posDist = this.Camera.position.distanceTo(this.targetPosition);
            const rotDist = this.currentLookVector.distanceTo(this.lookAtTarget);

            // If we are within 1cm and 1% of rotation, stop.
            if (posDist < 0.01 && rotDist < 0.01) {
                this.Camera.position.copy(this.targetPosition);
                this.currentLookVector.copy(this.lookAtTarget);
                this.Camera.lookAt(this.currentLookVector);
                
                this.isLerping = false;
                console.log("Movement Complete");
            }
            
            // DO NOT run orbit.update() while lerping
            return; 
        } 

        if (this.orbit.enabled) {
            this.orbit.update();
        }
    }
}